// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpRedirectContest_closeButton__E2fOz","rounded":"PopUpRedirectContest_rounded__4yE8n","image":"PopUpRedirectContest_image__aVa6u"};